import React from 'react';
import { Link } from 'react-router-dom';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleProcess from '../../components/Common/Process';

const Process = () => {
    return (
        <div id="rs-methodology" className="rs-process pt-180 pb-120 md-pt-70 md-pb-70">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-4 md-mb-40">
                        <div className="process-wrap">
                            <SectionTitle
                                sectionClass="sec-title mb-30"
                                subtitleClass="sub-text new"
                                subtitle="Working Process"
                                titleClass="title white-color"
                                title="Your Success Our Mission"
                            />
                           <div className="btn-part mt-40">
    <a 
        href="#rs-contact" 
        className="readon learn-more contact-us" 
        onClick={(e) => {
            e.preventDefault();
            document.getElementById("rs-contact")?.scrollIntoView({ behavior: 'smooth' });
        }}
    >
        Contact Us
    </a>
</div>
                        </div>
                    </div>
                    <div className="col-lg-8 pl-30 md-pl-15">
                        <div className="row">
                            <div className="col-md-6 mb-40 MethodologyDetails">
                                <SingleProcess 
                                    processNumber="1"
                                    processTitle="Discovery"
                                    processText={
                                        <>
                                            <b>Understanding Your Needs:</b> We begin by thoroughly understanding your business objectives, challenges, and requirements. Through collaborative discussions and detailed analysis, we define the project scope and lay the groundwork for success.
                                        </>
                                    }
                                />                                
                            </div>
                            <div className="col-md-6 mb-40 MethodologyDetails">                                
                                <SingleProcess 
                                    processNumber="2"
                                    processTitle="Planning"
                                    processText={
                                        <> 
                                            <b>Strategic Roadmap:</b> Based on the discovery phase, we create a detailed project plan. This includes defining timelines, milestones, resource allocation, and risk assessment, ensuring a clear path to achieving your goals.
                                        </>
                                    }
                                />
                            </div>
                            <div className="col-md-6 sm-mb-40 MethodologyDetails">
                                <SingleProcess 
                                    processNumber="3"
                                    processTitle="Execution"
                                    processText={
                                        <>
                                            <b>Implementation & Development:</b> Our skilled team translates the plan into action, employing industry best practices and cutting-edge technologies. We focus on efficient execution, quality assurance, and continuous communication to deliver results.
                                        </>
                                    }
                                />
                            </div>
                            <div className="col-md-6 MethodologyDetails">
                                <SingleProcess 
                                    processNumber="4"
                                    processTitle="Delivery"
                                    processText={
                                        <>
                                            <b>Launch & Support:</b> We ensure a smooth launch of your solution, providing comprehensive testing and validation. Our commitment extends beyond delivery with ongoing support and maintenance to ensure long-term success and satisfaction.
                                        </>
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Process;
